var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {},
      _vm._l(
        _vm.getSortedComments(_vm.task.task_data?.report?.comments ?? []),
        function (c, i) {
          return _c(
            "div",
            { key: i, staticClass: "border mb-1 p-2 bg-white shadow-sm" },
            [
              _c("div", {
                staticClass: "text_block",
                domProps: { innerHTML: _vm._s(c.text) },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-right fs-11" }, [
                _vm._v(_vm._s(c.user_name) + " "),
                _c("span", { staticClass: "ml-1 text-muted" }, [
                  _vm._v(_vm._s(_vm.printDate(c.created_at))),
                ]),
              ]),
            ]
          )
        }
      ),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex mt-2 new_comment_block" },
      [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.comment,
              expression: "comment",
            },
          ],
          staticClass: "form-control",
          attrs: { placeholder: "Комментарий по задаче...", cols: "4" },
          domProps: { value: _vm.comment },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.comment = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.task.id
          ? _c("LoadingButton", {
              attrs: {
                title: "Сохранить комментарий",
                loading: _vm.loading,
                color: _vm.$constants.SUCCESS_COLOR,
                onClick: () => _vm.saveComment(),
                className: "btn btn-outline-success",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }